import React from 'react';
import { Link, TextBoldness, Typography, getClassNameFactory } from '@dcl/ui';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { LinkTypes } from '@dcl/ui/dist/elements/Link';
import { IContactHubEmailSupport } from './ContactHubEmailSupportTypes';
import './index.css';

export const ContactHubEmailSupport: React.FC<IContactHubEmailSupport> = (
  props
) => {
  const { emailId, emailDescription, emailDisplayText, boldText } = props;

  const getClassName = getClassNameFactory(ContactHubEmailSupport.displayName);

  return (
    <div className={getClassName({ descendantName: 'container' })}>
      <div
        className={getClassName({
          descendantName: boldText ? 'emailAddressBold' : 'emailAddress',
        })}
      >
        <Link
          href={`mailto:${emailId}`}
          data-testid={'email'}
          type={LinkTypes.INLINE}
        >
          {emailDisplayText}
        </Link>
      </div>
      {emailDescription ? (
        <Typography
          tag={TypographyTags.SPAN}
          boldness={TextBoldness.Regular}
          className={getClassName({
            descendantName: 'emailDescription',
          })}
        >
          {emailDescription}
        </Typography>
      ) : null}
    </div>
  );
};

ContactHubEmailSupport.displayName = 'ContactHubEmailSupport';
